<template>
	<div class="price-page">
		<div class="content-box small">
			<div class="container">
                <h2 class="headline">{{$t('pricingboxes.headline')}} <span>{{$t('pricingboxes.headline-purple')}}</span></h2>
                <p class="headline">{{$t('pricingboxes.text')}}</p>

                <div class="pricing-table">
					<div class="col">
						<div class="pricebox basic">
							<p class="title">{{$t('pricingboxes.basic.title')}}</p>
							<h2>{{$t('pricingboxes.basic.price')}}</h2>
							<p>{{$t('pricingboxes.basic.price-label')}}</p>

							<ul>
								<li>{{$t('pricingboxes.basic.li-one')}}</li>
								<li>{{$t('pricingboxes.basic.li-two')}}</li>
								<li>{{$t('pricingboxes.basic.li-three')}}</li>
							</ul>

							<a href="https://www.rently.dk/priser/#on-demand" target="_blank" class="extra-box">
								<p>{{ $t('pricingboxes.basic.on-demand') }}  <span>On Demand</span></p>
							</a>

							<button v-on:click="useFreePlan">
								<svg xmlns="http://www.w3.org/2000/svg" width="13.895" height="10.38" viewBox="0 0 27.79 20.76">
  									<path class="fill-green" d="M1685.31,1583.51l-16.8,16.8a2.256,2.256,0,0,1-3.02,0l-6.8-6.8a1.994,1.994,0,1,1,2.82-2.82l5.49,5.48,15.49-15.48A1.994,1.994,0,1,1,1685.31,1583.51Z" transform="translate(-1658.12 -1580.12)"/>
								</svg>
								{{$t('pricingboxes.button.current-plan')}}
							</button>
						</div>
					</div>
					<div class="col">
						<div class="pricebox unlimited">
							<p class="title">{{$t('pricingboxes.unlimited.title')}}</p>
								<!-- Annual prices -->
								<template v-if="showAnually">
									<template v-if="getAnnualPrice != getAnnualDiscount">
										<h3 style="color: #fff;text-decoration: line-through;">{{ getAnnualPrice }}</h3>
										<h2 style="color: #fff;">{{ getAnnualDiscount }}</h2>
									</template>
									<template v-else>
										<h2 style="color: #fff;">
											{{ getAnnualPrice }}
										</h2>
									</template>
								</template>

								<!-- Monthly prices -->
								<template v-else>
									<template v-if="getMonthlyPrice != getMonthlyDiscount">
										<h3 style="color: #fff;text-decoration: line-through;">{{ getMonthlyPrice }}</h3>
										<h2 style="color: #fff;">{{ getMonthlyDiscount }}</h2>
									</template>
									<template v-else>
										<h2 style="color: #fff;">{{ getMonthlyPrice }}</h2>
									</template>
								</template>

								<p>{{$t('pricingboxes.unlimited.price-label')}}</p>
								<div class="switcher">
									<label>
										<p id="mothly" :class="showAnually ? '' : 'check'">{{$t('pricingboxes.unlimited.label-monthly')}}</p>
										<div>
											<input id="pricing-checkbox" :checked="showAnually" type="checkbox" v-on:click="showAnually = !showAnually">
											<div class="switch">
												<span></span>
											</div>
										</div>
										<p id="anually" :class="showAnually ? 'check' : ''">
											<span class="badge">{{	$t('pricingboxes.unlimited.discount')  }}</span>
											{{$t('pricingboxes.unlimited.label-anually')}}
										</p>
									</label>
								</div>
								<ul>
									<li>
										<span>{{$t('pricingboxes.unlimited.label')}}</span> {{$t('pricingboxes.unlimited.li-one')}}
									</li>
									<li>
										<span>{{$t('pricingboxes.unlimited.label')}}</span> {{$t('pricingboxes.unlimited.li-two')}}
									</li>
									<li>
										<span>{{$t('pricingboxes.unlimited.label')}}</span> {{$t('pricingboxes.unlimited.li-three')}}
									</li>
									<li>
										<span>{{$t('pricingboxes.unlimited.label')}}</span> {{$t('pricingboxes.unlimited.li-five')}}
									</li>
									<li>
										<span>{{$t('pricingboxes.unlimited.priority')}}</span> {{$t('pricingboxes.unlimited.li-four')}}
									</li>
								</ul>
								<a href="https://www.rently.dk/priser/#on-demand" target="_blank" class="extra-box">
									<p>{{ $t('pricingboxes.unlimited.on-demand') }}  <br><span>On Demand</span></p>
								</a>
								<a v-on:click="usePaidPlan" class="button white">{{$t('pricingboxes.button.upgrade')}}</a>
							</div>

					</div>

					<div class="col">
						<div class="pricebox basic">
							<p class="title">
								{{$t('pricingboxes.contact.title')}}
							</p>
							<h2>
								{{$t('pricingboxes.contact.headline')}}
							</h2>
							<p>
								{{$t('pricingboxes.contact.headline-label')}}
							</p>
							<ul class="content">
								<li>
									{{$t('pricingboxes.contact.text')}}
								</li>
							</ul>

							<a href="https://www.rently.dk/support/" target="_blank" class="button green">
								{{$t('pricingboxes.button.contact')}}
							</a>
						</div>
					</div>

				</div>

            </div>
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {mapGetters} from 'vuex';


    export default {
    	data: () => ({
    		showAnually: true,
    		freePlan: true,
    		prices: false
		}),
    	computed: {
    		...mapGetters([
    			'getToken'
    		]),
    		getMonthlyPrice() {
    			return this.prices == false ? 'Loading' : Math.round(this.prices[3].price);
    		},
    		getAnnualPrice() {
    			return this.prices == false ? 'Loading' : Math.round(this.prices[4].price / 12);
    		},
    		getMonthlyDiscount() {
    			return this.prices == false ? '' : Math.round(this.prices[3].discount);
    		},
    		getAnnualDiscount() {
    			return this.prices == false ? '' : Math.round(this.prices[4].discount / 12);
    		}
    	},
    	methods: {
    		useFreePlan() {
    			this.freePlan = true;
    			this.sendSelection();
    		},
    		usePaidPlan() {
    			this.freePlan = false;
    			this.sendSelection();
    		},
    		getSelection() {
    			return !this.freePlan ? (this.showAnually ? 4 : 3) : 2;
    		},
    		sendSelection() {
    			this.$emit('selection');
    		},
    		checkboxSlide: function(){
                //this.showAnually = !this.showAnually
            }
    	},
    	created() {
    		axios({
    			method: 'GET',
    			url: window.config.apiUrl + 'api/prices',
				cancelToken: window.AuthorizationCancelSource.token,
    		}).then(response => {
    			this.prices = response.data;
    		});
    	}
    }

</script>
